module.exports = __webpack_public_path__ + "img/gallery11.f5e129ab.png";